var React = require('react');

function IconSliders (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","clipRule":"evenodd","fill":"currentColor"},[React.createElement("path",{"d":"M10.95 10a2.511 2.511 0 0 0 0-1h1.55a.5.5 0 0 1 0 1h-1.55zm-4.9 0H.5a.5.5 0 0 1 0-1h5.55a2.512 2.512 0 0 0 0 1z","key":0}),React.createElement("path",{"d":"M8.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM6.95 3a2.512 2.512 0 0 0 0-1h5.55a.5.5 0 0 1 0 1H6.95zm-4.9 0H.5a.5.5 0 0 1 0-1h1.55a2.512 2.512 0 0 0 0 1z","key":1}),React.createElement("path",{"d":"M4.5 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z","key":2})]));
}

IconSliders.defaultProps = {"viewBox":"0 0 13 12","fill":"none"};

module.exports = IconSliders;

IconSliders.default = IconSliders;
